
<!-- https://leafletjs.com/ -->
<template>
  <v-container>
    <v-card>
      <v-card-title>🌍 Nuestros visitantes</v-card-title>
      <v-card-text>
        <div id="map" style="height: 500px;"></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import visitasService from "@/services/visitasService.js";

// Corregir rutas de los íconos
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  name: 'MapaMundial',
  data() {
    return {
      mapa: null,
      ubicaciones: [
       
      ]
    }
  },
async  mounted() {
    this.initMapa();
   await this.cargarDatosVisitas();
    this.marcarUbicaciones();
   
  },
  methods: {

   async cargarDatosVisitas() {
  try {
    const respuesta = await visitasService.getVisitasMap()
    this.ubicaciones = respuesta.data.ubicaciones;
    console.log(respuesta.data.ubicaciones)


     
  } catch (e) {
    this.errors = e.response?.data?.errors || {}
    console.log(this.errors)
  }
}
,



    initMapa() {
      this.mapa = L.map('map', {
        zoomControl: false,        // sin controles de zoom
        dragging: false,           // no permitir arrastrar
        scrollWheelZoom: false,    // no permitir zoom con rueda del mouse
        doubleClickZoom: false,    // no permitir zoom con doble clic
        boxZoom: false,
        keyboard: false,
        touchZoom: false,          // no permitir zoom con gestos táctiles
        tap: false
      })

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
      }).addTo(this.mapa)
    },
  /*  marcarUbicaciones() {
      const bounds = []

      this.ubicaciones.forEach(ubicacion => {
        const latLng = [ubicacion.latitude, ubicacion.longitude]
        bounds.push(latLng)
        L.marker(latLng).addTo(this.mapa)
      })

      if (bounds.length > 0) {
        this.mapa.fitBounds(bounds, {
          padding: [50, 50],
          maxZoom: 2 // evita que se acerque demasiado
        })
      }
    }*/
  marcarUbicaciones() {
  const bounds = [];

  this.ubicaciones.forEach(ubicacion => {
    const lat = parseFloat(ubicacion.latitude)
    const lng = parseFloat(ubicacion.longitude)

    if (!isNaN(lat) && !isNaN(lng)) {
      const latLng = [lat, lng];
      bounds.push(latLng);
      L.marker(latLng).addTo(this.mapa);
    }
  });

  if (bounds.length > 0) {
    this.mapa.fitBounds(bounds, {
      padding: [50, 50],
      maxZoom: 2
    });
  }
}

  }
}
</script>

<style scoped>
#map {
  height: 100%;
  width: 100%;
  z-index: 0;
}
</style>
